import GUI from "lil-gui";

import globals from "./globals";
import parameterValues from "./parameterValues";
import { simulationUniforms, displayUniforms } from "./uniforms";
import { drawFirstFrame, InitialTextureTypes } from "./firstFrame";
import { exportImage } from "./exportImage";

export let currentSeedType = InitialTextureTypes.RANDOM_POINTS;

const FONT_OPTIONS = {
  Gulax: "Gulax",
  PicNic: "PicNic",
  "Google Sans Code": "Google Sans Code",
  "Syne Mono": "Syne Mono",
};

function rgbToBwHigh(value) {
  const r = value.r > 1 ? value.r / 255 : value.r;
  const g = value.g > 1 ? value.g / 255 : value.g;
  const b = value.b > 1 ? value.b / 255 : value.b;
  displayUniforms.bwColorHigh.value.set(r, g, b);
}

function rgbToBwLow(value) {
  const r = value.r > 1 ? value.r / 255 : value.r;
  const g = value.g > 1 ? value.g / 255 : value.g;
  const b = value.b > 1 ? value.b / 255 : value.b;
  displayUniforms.bwColorLow.value.set(r, g, b);
}

/**
 * @param {GUI} gui
 */
export function setupRightPaneGui(gui) {
  const maskFolder = gui.addFolder("Text Mask");
  maskFolder
    .add(parameterValues.mask, "enabled")
    .name("Enable")
    .onChange((v) => {
      simulationUniforms.maskEnabled.value = v ? 1.0 : 0.0;
    });
  maskFolder
    .add(parameterValues.mask, "text")
    .name("Content")
    .onChange(() => drawFirstFrame(currentSeedType));
  maskFolder
    .add(parameterValues.mask, "textSize", 100, 800, 1)
    .name("Text size")
    .onChange(() => drawFirstFrame(currentSeedType));
  maskFolder
    .add(parameterValues.mask, "fontFamily", FONT_OPTIONS)
    .name("Font")
    .onChange(() => drawFirstFrame(currentSeedType));
  maskFolder.open();

  const renderingFolder = gui.addFolder("Colors");
  const tt = parameterValues.twoToneColors;
  renderingFolder
    .addColor(tt, "colorHighRGB", 255)
    .name("Background")
    .onChange(() => rgbToBwHigh(tt.colorHighRGB));
  renderingFolder
    .addColor(tt, "colorLowRGB", 255)
    .name("Foreground")
    .onChange(() => rgbToBwLow(tt.colorLowRGB));
  renderingFolder.open();

  const postFolder = gui.addFolder("Post (blur / CA)");
  const pp = parameterValues.postProcess;
  postFolder
    .add(pp, "blurRadius", 0, 8, 0.05)
    .name("Distort")
    .onChange((v) => {
      displayUniforms.blurRadius.value = v;
    });
  postFolder
    .add(pp, "chromaticAberration", 0, 6, 0.05)
    .name("Color shift")
    .onChange((v) => {
      displayUniforms.chromaticAberration.value = v;
    });
  postFolder.open();

  const actionsFolder = gui.addFolder("Actions");
  const actions = {
    restart() {
      drawFirstFrame(currentSeedType);
    },
    clear() {
      drawFirstFrame(InitialTextureTypes.EMPTY);
    },
    pausePlay() {
      globals.isPaused = !globals.isPaused;
    },
    saveImage() {
      exportImage();
    },
  };
  actionsFolder.add(actions, "restart").name("⟳ Restart");
  actionsFolder.add(actions, "clear").name("⌧ Clear");
  actionsFolder.add(actions, "pausePlay").name("⏸ Pause/play");
  actionsFolder.add(actions, "saveImage").name("⤓ Export img");
  actionsFolder.open();
}
